import { Controller } from "@hotwired/stimulus";
import { renderMarkdown } from "../../markdown_renderer.js";

export default class extends Controller {
  static targets = ["textarea", "status", "copyPrefSelect", "preview", "editBtn", "previewBtn"];
  static values = {
    saveUrl: String,
    prefsUrl: String,
    msgUnsaved: String,
    msgSaving: String,
    msgSaved: String,
    msgSaveFailed: String,
    msgSaveFailedNet: String,
  };

  connect() {
    this._timer = null;
    this._statusClearTimer = null;
  }

  disconnect() {
    clearTimeout(this._timer);
    clearTimeout(this._statusClearTimer);
  }

  scheduleAutosave() {
    clearTimeout(this._timer);
    clearTimeout(this._statusClearTimer);
    this._timer = setTimeout(() => this.saveNow(), 1000);
    this._setStatus(this.msgUnsavedValue);
  }

  showEdit() {
    this.textareaTarget.classList.remove("hidden");
    this.previewTarget.classList.add("hidden");
    this.editBtnTarget.setAttribute("aria-pressed", "true");
    this.previewBtnTarget.setAttribute("aria-pressed", "false");
    this._setTabStyle(this.editBtnTarget, true);
    this._setTabStyle(this.previewBtnTarget, false);
  }

  showPreview() {
    this.previewTarget.innerHTML = renderMarkdown(this.textareaTarget.value);
    this.textareaTarget.classList.add("hidden");
    this.previewTarget.classList.remove("hidden");
    this.editBtnTarget.setAttribute("aria-pressed", "false");
    this.previewBtnTarget.setAttribute("aria-pressed", "true");
    this._setTabStyle(this.editBtnTarget, false);
    this._setTabStyle(this.previewBtnTarget, true);
  }

  async saveNow() {
    clearTimeout(this._timer);
    clearTimeout(this._statusClearTimer);
    const notes = this.textareaTarget.value;
    this._setStatus(this.msgSavingValue);
    try {
      const resp = await fetch(this.saveUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content ?? "",
        },
        body: JSON.stringify({ notes }),
      });
      if (resp.ok) {
        this._setStatus(this.msgSavedValue);
        this._statusClearTimer = setTimeout(() => this._setStatus(""), 2000);
      } else {
        this._setStatus(this.msgSaveFailedValue);
      }
    } catch {
      this._setStatus(this.msgSaveFailedNetValue);
    }
  }

  async saveCopyPreference(e) {
    const value = e.target.value;
    try {
      await fetch(this.prefsUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content ?? "",
        },
        body: JSON.stringify({ value }),
      });
    } catch {
      // preference save is best-effort; no user-facing error needed
    }
  }

  _setStatus(text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text;
  }

  _setTabStyle(btn, active) {
    btn.classList.toggle("bg-base-300", active);
    btn.classList.toggle("text-base-content", active);
    btn.classList.toggle("text-base-content/50", !active);
  }
}
